import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-recruitment',
  templateUrl: './recruitment.component.html',
  styleUrls: ['./recruitment.component.css']
})
export class RecruitmentComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, public encDec: EncryptDecryptService, private route: Router, public translate: TranslateService) { }
  c_start: number = 0;
  c_limit: number = 10;
  c_currentPage: number = 1;
  c_totalRecords: number = 0;

  p_start: number = 0;
  p_limit: number = 10;
  p_currentPage: number = 1;
  p_totalRecords: number = 0;
  language: any = sessionStorage.getItem('locale');//dynamic;

  plugin_menu_dtl: any;
  employee_con: any = "";
  showEmpMen: boolean = false;
  showNavComponent: boolean = false;
  showBarComponent: boolean = false;
  CurrentRouteFn: any = (): any => {
    let route_url: any = this.route.url.replace('/', "");
    route_url = route_url.split("?");
    if (route_url.length > 0) {
      return route_url[0];
    }
    return route_url;
  }

  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  datetime: any = this.httpservice.currentDateTime();
  ngOnInit(): void {
    this.p_start = (this.p_currentPage - 1) * this.p_limit;
    this.c_start = (this.c_currentPage - 1) * this.c_limit;
    document.title = "Recruitment";
    if (environment.ZONE_ID > 0) {

    } else {

    }
    this.CurrnetRecruitment('', '', '', this.c_start, this.c_limit, this.c_currentPage);
    this.PreviousRecruitment(this.p_start, this.p_limit, this.p_currentPage);

    this.TenderZoneList();
    this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
    if (this.employee_con == null) {
      this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
      this.getPluginPageDetials(this.plugin_menu_dtl);
    } else {
      this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
    }
  }

  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }
  backend_url: any = environment.serviceURL;

  pageChanged(page: any) {
    this.c_currentPage = page
    this.c_start = (this.c_currentPage - 1) * this.c_limit;
    this.CurrnetRecruitment('', '', '', this.c_start, this.c_limit, this.c_currentPage);
  }

  btncontent: any = this.language == 'English' ? `Search` : `खोजें`;

  ifdisabled: boolean = false;
  c_apirespons: any;
  current_data: any[] = [];
  CurrnetRecruitment(title: any, zone: any, RecruitmentType: any, start: number, limit: number, currentPage: number) {
    this.ifdisabled = true;
    this.btncontent = `<i class="spinner-border spinner-size" aria-hidden="true"></i>`;
    var query: any = [
      { "columnName": "R_TYPE", "operator": "=", "value": 1, "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
      { "columnName": "TYPE", "operator": "=", "value": 1, "joinoperator": "and" },
      { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
    ];

    let params = [
      {
        "secSlNo": 1,
        "offSet": '',//start,
        "noOfRecords": '',//limit,
        "orderBy": [{ "columnName": "INTSLNO", "type": "ASC" }],
        "condition": query,
        "viewParameters": ""
      }];
    this.httpservice.GetCurrnetRecruitment(params).subscribe((response: HttpEvent<any>) => {
      this.ifdisabled = false;
      this.btncontent = this.language == 'English' ? `Search` : `खोजें`;
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.c_apirespons = response.body;
          let respData = this.c_apirespons.RESPONSE_DATA;
          let respToken = this.c_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            let data: any[] = [];
            let list: any[] = response.result.sec_1;
            list.forEach((item: any) => {
              let f = item;
              let all_english_file_list: any[] = [];
              let all_hindi_file_list: any[] = [];
              f['all_english_file_list'] = all_english_file_list;
              f['all_hindi_file_list'] = all_hindi_file_list;

              if (item.document_details !== undefined) {
                if(item.document_details.fileSize!==""){
                  all_english_file_list.push({ type: 'english', filename: item.document, filesize: item.document_details.fileSize, filetype: item.document_details.fileType.toUpperCase(), fileicon: `<i class="fa fa-file-pdf-o" aria-hidden="true"></i>` });
                }
              }
              if (item.hindiDocument_details !== undefined) {
                if(item.hindiDocument_details.fileSize!==""){
                  all_hindi_file_list.push({ type: 'hindi', filename: item.hindiDocument, filesize: item.hindiDocument_details.fileSize, filetype: item.hindiDocument_details.fileType.toUpperCase(), fileicon: `<i class="fa fa-file-pdf-o" aria-hidden="true"></i>` });
                }
              }
              item.addMultipleFiles.forEach((filelist: any) => {
                if (filelist.englishDocument_details !== undefined) {
                  if(filelist.englishDocument_details.fileSize!==""){
                  all_english_file_list.push({ type: 'english', filename: filelist.englishDocument, filesize: filelist.englishDocument_details.fileSize, filetype: filelist.englishDocument_details.fileType.toUpperCase(), fileicon: `<i class="fa fa-file-pdf-o" aria-hidden="true"></i>` });
                  }
                }
                if (filelist.hindiDocument_details !== undefined) {
                  if(filelist.hindiDocument_details.fileSize!==""){
                  all_hindi_file_list.push({ type: 'hindi', filename: filelist.hindiDocument, filesize: filelist.hindiDocument_details.fileSize, filetype: filelist.hindiDocument_details.fileType.toUpperCase(), fileicon: `<i class="fa fa-file-pdf-o" aria-hidden="true"></i>` });
                  }
                }
              })
              data.push(f);
              all_english_file_list = [];
              all_hindi_file_list = [];
            })
            this.current_data = data;
            // console.log( this.current_data);
            if (response.result.sec_1.length > 0) {
              this.c_totalRecords = response.result.sec_1[0].noOfRec;
            } else {
              this.c_totalRecords = 0;
            }
          }

      }
    });
  }

  getFileList(item: any): any[] {
    let list = [];
    if (this.language == "English") {
      if (this.checkFileExists(item) == true) {
        list.push({ filename: item.document, filesize: item.documen, filetype: item.document, fileicon: item.document })
      }
    } else {

    }

    return [];
  }


  viewDetails(id: any, pageName: any, title: any, titleInHindi: any, type: any) {

    let notice = { 'title': title, 'titleInHindi': titleInHindi };
    sessionStorage.setItem('notice', JSON.stringify(notice));

    let encSchemeStr = this.encDec.encText(`${id.toString()}:${type.toString()}`);
    // console.log('/'+ pageName +'/', encSchemeStr);
    this.route.navigate(['/' + pageName + '/', encSchemeStr]);
  }

  p_pageChanged(page: any) {
    this.p_currentPage = page
    this.p_start = (this.p_currentPage - 1) * this.p_limit;
    this.PreviousRecruitment(this.p_start, this.p_limit, this.p_currentPage);
  }

  p_apirespons: any;
  previous_data: any[] = [];
  PreviousRecruitment(start: number, limit: number, currentPage: number) {
    var query = [
      { "columnName": "R_TYPE", "operator": "=", "value": 2, "joinoperator": "and" },
      { "columnName": "TYPE", "operator": "=", "value": 1, "joinoperator": "and" },
      { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },

    ];
    let params = [
      {
        "secSlNo": 1,
        "offSet": start,
        "noOfRecords": limit,
        "orderBy": [{ "columnName": "PUBLISH_DATE", "type": "ASC" }],
        "condition": query,
        "viewParameters": ""
      }];


    this.httpservice.GetPreviousRecruitment(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.p_apirespons = response.body;
          let respData = this.p_apirespons.RESPONSE_DATA;
          let respToken = this.p_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            let data: any[] = [];
            let list: any[] = response.result.sec_1;
            list.forEach((item: any) => {
              let f = item;
              let all_english_file_list: any[] = [];
              let all_hindi_file_list: any[] = [];
              f['all_english_file_list'] = all_english_file_list;
              f['all_hindi_file_list'] = all_hindi_file_list;

              if (item.document_details !== undefined) {
                if(item.document_details.fileSize!==""){
                  all_english_file_list.push({ type: 'english', filename: item.document, filesize: item.document_details.fileSize, filetype: item.document_details.fileType.toUpperCase(), fileicon: `<i class="fa fa-file-pdf-o" aria-hidden="true"></i>` });
                }
              }
              if (item.hindiDocument_details !== undefined) {
                if(item.hindiDocument_details.fileSize!==""){
                  all_hindi_file_list.push({ type: 'hindi', filename: item.hindiDocument, filesize: item.hindiDocument_details.fileSize, filetype: item.hindiDocument_details.fileType.toUpperCase(), fileicon: `<i class="fa fa-file-pdf-o" aria-hidden="true"></i>` });
                }
              }
              item.addMultipleFiles.forEach((filelist: any) => {
                if (filelist.englishDocument_details !== undefined) {
                  if(filelist.englishDocument_details.fileSize!==""){
                  all_english_file_list.push({ type: 'english', filename: filelist.englishDocument, filesize: filelist.englishDocument_details.fileSize, filetype: filelist.englishDocument_details.fileType.toUpperCase(), fileicon: `<i class="fa fa-file-pdf-o" aria-hidden="true"></i>` });
                  }
                }
                if (filelist.hindiDocument_details !== undefined) {
                  if(filelist.hindiDocument_details.fileSize!==""){
                  all_hindi_file_list.push({ type: 'hindi', filename: filelist.hindiDocument, filesize: filelist.hindiDocument_details.fileSize, filetype: filelist.hindiDocument_details.fileType.toUpperCase(), fileicon: `<i class="fa fa-file-pdf-o" aria-hidden="true"></i>` });
                  }
                }
              })
              data.push(f);
              all_english_file_list = [];
              all_hindi_file_list = [];
            })
            this.previous_data = data;
            //  console.log(this.previous_data);
            if (response.result.sec_1.length > 0) {
              this.p_totalRecords = response.result.sec_1[0].noOfRec;
            } else {
              this.p_totalRecords = 0;
            }
          }
      }
    });
  }





  jsonConvert(data: any, type: any) {
    if (data == null || data == "") {
      return "";
    }
    if (data.jsonOptTxtDetails == "" || data.jsonOptTxtDetails == null) {
      return "";
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'CATEGORY') {
      return d.CATEGORY;
    } else {
      return '';
    }

  }

  htmlTag(data: any) {
    return this.encDec.decodeHtml(data);
  }




  goToExtLink(url: any) {
    Swal.fire({
      title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
      }
    });
  }


  checkFileExists(obj: any): boolean {
    if (obj.document == "") {
      return false;
    }
    if (obj.document_details == undefined) {
      return false;
    }
    if (obj.document_details.fileSize == undefined) {
      return false;
    }
    if (obj.document_details.fileSize == "") {
      return false;
    }
    return true;
  }


  checkFileExists_(obj: any): boolean {
    if (obj.hindiDocument == "") {
      return false;
    }
    if (obj.hindiDocument_details == undefined) {
      return false;
    }
    if (obj.hindiDocument_details.fileSize == undefined) {
      return false;
    }
    if (obj.hindiDocument_details.fileSize == "") {
      return false;
    }
    return true;
  }


  emp_apires: any;
  emp_dtl: any = { 'title': '' };
  getEmployeeCornerDtl(id: any) {
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],
        "condition": [
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value": id, "joinoperator": "and" },
        ],
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.emp_apires = response.body;
          let respData = this.emp_apires.RESPONSE_DATA;
          let respToken = this.emp_apires.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response_: any = Buffer.from(respData, 'base64');
            response_ = JSON.parse(response_);
            if (response_.result.sec_1.length > 0) {
              this.emp_dtl = response_.result.sec_1[0];
              this.showBarComponent = true;
              this.showEmpMen = true;
            }
          }
      }
    });
  }











  navmenuloadCss = "background-color: #167a44; height: 100%;";
  p_apirespons_: any;
  P_data: any;

  navMenu: boolean = false;
  getPluginPageDetials(details: any) {
    let params;
    if (details !== null) {
      let d = JSON.parse(details);
      params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": d.plugin_id,
        'router_link': d.selectPlugin,
        'localdata': true,
      };
    } else {
      params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": false,
        'router_link': this.CurrentRouteFn(),
        'localdata': false,
      };
    }
    this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.p_apirespons_ = response.body;
          let respData = this.p_apirespons_.RESPONSE_DATA;
          let respToken = this.p_apirespons_.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response_: any = Buffer.from(respData, 'base64');
            response_ = JSON.parse(response_);
            if (response_.original.status) {
              this.P_data = response_.original;
              this.navMenu = response_.original.hasMenu;
              this.navmenuloadCss = "height: 100%;";
            } else {
              this.P_data = response_.original;//somthing wrong
            }
            this.showNavComponent = true;
            this.showBarComponent = true;
          }
      }
    });
  }



  categoryLanguage(id: any): any {
    if (id == 1) {
      return this.language == 'English' ? 'Category I' : 'वर्ग १';
    } else if (id == 2) {
      return this.language == 'English' ? 'Category II' : 'वर्ग २';
    } else if (id == 3) {
      return this.language == 'English' ? 'Category III' : 'वर्ग ३';
    } else if (id == 4) {
      return this.language == 'English' ? 'Category IV' : 'वर्ग ४';
    }
    else if (id == 5) {
      return this.language == 'English' ? 'Not Available' : 'उपलब्ध नहीं है';
    }
    return "";
  }

  checkFileType_(data: any): any {
    let ext: any, fileType: any;
    ext = ['webp', 'jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG', 'xlsx', 'xls', 'csv', 'docx', 'doc'];
    if (data == "") {
      return false;
    }
    if (data.hindiDocument == "") {
      return false;
    }
    if (data.hindiDocument_details == undefined) {
      return false;
    }
    if (data.hindiDocument_details.fileType == undefined) {
      return false;
    }
    if (data.hindiDocument_details.fileType == '') {
      return false;
    }
    fileType = data.hindiDocument_details.fileType.toLowerCase();
    if (fileType == 'xlsx' || fileType == 'xls' || fileType == 'csv') {
      return { 'fileType': fileType, 'file': `|| <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType}` };
    } else if (fileType == 'docx' || fileType == 'doc') {
      return { 'fileType': fileType, 'file': `|| <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType}` };
    } else if (fileType == 'pdf') {
      return { 'fileType': fileType, 'file': `|| <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType}` };
    } else {
      return { 'fileType': fileType, 'file': `|| <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType}` };
    }
  }

  checkFileType(data: any): any {
    let ext: any, fileType: any;
    ext = ['webp', 'jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG', 'xlsx', 'xls', 'csv', 'docx', 'doc'];
    if (data == "") {
      return false;
    }
    if (data.document == "") {
      return false;
    }
    if (data.document_details == undefined) {
      return false;
    }
    if (data.document_details.fileType == undefined) {
      return false;
    }
    if (data.document_details.fileType == '') {
      return false;
    }
    fileType = data.document_details.fileType.toLowerCase();
    if (fileType == 'xlsx' || fileType == 'xls' || fileType == 'csv') {
      return { 'fileType': fileType, 'file': `|| <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType}` };
    } else if (fileType == 'docx' || fileType == 'doc') {
      return { 'fileType': fileType, 'file': `|| <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType}` };
    } else if (fileType == 'pdf') {
      return { 'fileType': fileType, 'file': `|| <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType}` };
    } else {
      return { 'fileType': fileType, 'file': `|| <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType}` };
    }
  }

  searchForm = new FormGroup({
    title: new FormControl(''),
    RecruitmentType: new FormControl(''),
    zone: new FormControl(''),
  })
  get RecruitmentType() {
    return this.searchForm.get('RecruitmentType');
  }
  get title() {
    return this.searchForm.get('title');
  }
  get zone() {
    return this.searchForm.get('zone');
  }
  RefreshBtn: boolean = false;
  RefreshPage() {
    this.c_start = 0;
    this.c_limit = 10;
    this.c_currentPage = 1;
    this.c_totalRecords = 0;
    this.CurrnetRecruitment('', '', '', this.c_start, this.c_limit, this.c_currentPage);
    this.RefreshBtn = false;
    this.searchForm.reset();
    $('select#zone').prop('selectedIndex', 0);
    $('select#RecruitmentType').prop('selectedIndex', 0);
  }



  issearch: any;
  isdisplay: boolean = false;
  searchTender() {
    let param_arr = [];
    this.isdisplay = true;
    let title, RecruitmentType, zone;
    RecruitmentType = "";
    title = "";
    zone = "";
    if (this.searchForm.value.RecruitmentType !== "") {
      if (this.searchForm.value.RecruitmentType !== null) {
        param_arr.push(this.searchForm.value.RecruitmentType);
        RecruitmentType = this.searchForm.value.RecruitmentType;
      }
    }
    if (this.searchForm.value.title !== "") {
      if (this.searchForm.value.title !== null) {
        param_arr.push(this.searchForm.value.title);
        title = this.searchForm.value.title;
      }
    }

    if (this.searchForm.value.zone !== "") {
      if (this.searchForm.value.zone !== null) {
        param_arr.push(this.searchForm.value.zone);
        zone = this.searchForm.value.zone;
      }
    }

    if (param_arr.length <= 0) {
      if (this.language == 'English') {
        alert('Please select at least one parameter');
      } else {
        alert('कृपया कम से कम एक पैरामीटर चुनें');
      }
      return;
    }
    this.RefreshBtn = true;
    this.c_start = 0;
    this.c_limit = 10;
    this.c_currentPage = 1;
    this.c_totalRecords = 0;
    this.CurrnetRecruitment(title, zone, RecruitmentType, this.c_start, this.c_limit, this.c_currentPage);
  }



  zone_apirespons: any;
  zoneList: any[] = [];
  TenderZoneList() {
    this.httpservice.getZoneList().subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.data;
          }
      }
    });
  }

  getZonename(dtl: any): any {
    let zonelist: any[] = this.zoneList;
    let name: any = '';
    let zoneid: any = dtl.selectZone == undefined ? '' : dtl.selectZone;
    zonelist.forEach((item: any) => {
      if (item.int_Demographic_Id == zoneid) {
        name = this.language == "English" ? item.vch_Demographic_Name : item.vch_Demographic_Name_Hindi;
      }
    });
    return name;
  }







}
